import './mega-menu-styles.scss';
import initWindows from './mega-menu-window';
import { scrollDocument } from './mega-menu-scroll';

scrollDocument();
initWindows({
  control: '#burger-nav-js',
  target: '#nav-list-movil-js'
});
